var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "responsiveSection resultRow", attrs: { id: "resultRow" } },
    [
      _c("div", { staticClass: "responsiveSection__grid gridBox" }, [
        _c("div", { staticClass: "search__grid search__gridHeadlineRow" }, [
          _c(
            "div",
            {
              staticClass:
                "flex flex__justifyContent--spaceBetween search__grid--left",
            },
            [
              _c("div", { staticClass: "flex" }, [
                _c("span", { staticClass: "hideOnMobile" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "flex flex__alignItems--center headline__totalResult headline__totalResult--bold",
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.trans("TOTAL_RESULTS").toUpperCase()) +
                          ":\n                        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "flex flex__alignItems--center headline__totalResult",
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.numberFormat(_vm.totalFound)) +
                        " " +
                        _vm._s(_vm.trans("RESULTS"))
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex__justifyContent--end sortBox search__grid--middle hideOnMobile",
                  attrs: { id: "searchOptions" },
                },
                [
                  _c("CustomDropdown", {
                    attrs: {
                      id: "inlineDropdown__sort",
                      "data-gtm": "searchResults--sort",
                      default: _vm.sortOptions[0],
                      element: "sort",
                      value: _vm.sortOption,
                      options: _vm.sortOptions,
                    },
                    on: { changeValue: _vm.selectSort },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "searchbar__expert--mobile button search__grid--right moreFilters hideOnDesktop",
              attrs: {
                type: "button",
                "data-gtm": "search__expertSearch--mobile",
                "aria-label": "Expert search",
              },
              on: {
                click: function ($event) {
                  return _vm.updateShowSidebar(true)
                },
              },
            },
            [
              _c("span", { staticClass: "moreFilters--mobile display-flex" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.trans("FORM_FILTER")) +
                    "\n                    "
                ),
                _vm.selectedFilterNumber > 0
                  ? _c("span", { staticClass: "margin-left-5" }, [
                      _vm._v(
                        "\n                        (" +
                          _vm._s(_vm.selectedFilterNumber) +
                          ")\n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "svg",
                  {
                    attrs: { height: "16", width: "16", "aria-hidden": "true" },
                  },
                  [_c("use", { attrs: { href: "#iconDisplayOptionsRegular" } })]
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "search__grid--right flex flex__alignItems--center hideOnMobile",
            },
            [
              _c("p", { staticClass: "headline__search" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.trans("REFINE_YOUR_SEARCH")) +
                    "\n                "
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }